import axios from 'axios';
import { message as antMessage } from 'antd';
import {getParameterByName, removeURLParameter, hrefChangeUrl} from "@/utils/utils";

antMessage.config({ maxCount: 1 });
// api请求实例
// eslint-disable-next-line no-undef
const domain = process.env.NODE_ENV === 'development' ? process.env.SERVER_DOMAIN : SERVER.SERVER_DOMAIN;

const instance = axios.create({
  baseURL: domain + '/api',
  timeout: 20000,
});

instance.interceptors.request.use(
  config => {
      config.headers["Crm-Platform-Type"] = window.crm_platform_type;
      config.headers["User-Token"] = window.current_user_token;
    return config;
  },
  err => Promise.reject(err)
);
// 响应拦截器
instance.interceptors.response.use(function(res) {
  const { code, message, requestId } = res.data;
  const errorCode = getParameterByName('errorCode')
  if(code !== 0) {
    // http://wiki.weiwenjia.com:53435/confluence/pages/viewpage.action?pageId=145555630
    // 错误map文件 constant/errorCode.js

    const strCode = `${code}`;
    //后端接口统一错误码为7位
    if(strCode.length === 7){
      const lastChar = strCode.charAt(strCode.length - 1);
      if(lastChar !== "2"){
        /**
         * 1002041 企微助手未绑定，需跳转登录url
        */

        if (strCode === '1002041' ) {
          // window.location.href = message;
          hrefChangeUrl(message);
          return;
        }

        //末尾为0则普通弹窗提示，末尾为1则需要后续处理业务逻辑
        antMessage.error(message);

      }else if(lastChar === "2"){
        //末尾为2用户错误，url处理errorCode
        /**
         * 1002052 用户不可见
         * 1002032 权限设置：用户无操作权限
         * 1002062 权限设置：最后一个超管不能变更为普通用户
        */

        // 用户不存在
        if (strCode === '1002022' ) {
          antMessage.error(message);
        }
        // h5接口报错无权限，直接跳转无权限页面
        if(strCode === "1002032" && getParameterByName("deviceType") === "h5Side"){
          const newUrl = window.location.href.split("#")[0] + `#/h5-no-permission`;
          window.location.replace(newUrl);
          return
        }

        // 后端权限缓存，解绑后5分钟才能生效，调用接口返回1002042，跳转无权限页面
        if(strCode === "1002042" || strCode === "1002032"){
          antMessage.error(message);
        }
      }
    }else if(code === 500){
      //code500为后端某些接口有逻辑问题，没有传回正常的7位错误code，提示后返回数据给接口调用处特殊处理
      //某些接口有逻辑问题,没有返回正常的message
      if(message) {
        antMessage.error(message);
      }
    }else{
      return Promise.reject(res.data);
    }
  } else {
    if (errorCode) {
      // window.location.href = removeURLParameter(window.location.href, errorCode);
      hrefChangeUrl(removeURLParameter(window.location.href, errorCode));
    }
  }
  return {
    success: code === 0,
    requestId: requestId,
    ...res.data
  };
}, function (error) {
  console.log(error);
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default instance
